(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
var footerUx;
var footerChatRoot;
var footerChatObserver;
var footerFeedbackRoot;
var footerFeedbackObserver;
var footerTrustRoot;
var footerTrustObserver;
var footerCaptcha;
var footerCaptchaObserver = window.ResizeObserver ? new ResizeObserver(footerScheduleUpdate) : null;
var footerUpdateScheduled = false;
var footerMobileQuery = window.matchMedia('(max-width: 599px)');
var footerAccordionMode;
var footerResizeObserver = window.ResizeObserver ? new ResizeObserver(footerScheduleUpdate) : null;
var footerWidgetSelector = '#cx-armin-chat-widget-v2, [id^="hj-survey-toggle-"], [id^="trustbadge-container-"], .grecaptcha-badge';

function footerSetProperty(element, name, value) {
  if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
}

function footerWidgetVisible(element) {
  if (!element || !element.getClientRects().length) return false;
  var style = window.getComputedStyle(element);
  return style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
}

function footerFloatingTop(height, width, bottom, minimum) {
  var left = document.documentElement.clientWidth - 16 - width;
  var blocked = [];
  var walker = document.createTreeWalker(footerUx, NodeFilter.SHOW_TEXT);
  var node;
  while ((node = walker.nextNode())) {
    if (!node.textContent.trim()) continue;
    var parent = node.parentElement;
    if (!parent || parent.closest('script, style, .footer__trust-fallback')) continue;
    if (parent.closest('details:not([open])') && !parent.closest('summary')) continue;
    var style = window.getComputedStyle(parent);
    if (style.display === 'none' || style.visibility === 'hidden') continue;
    var range = document.createRange();
    range.selectNodeContents(node);
    Array.from(range.getClientRects()).forEach(function(rect) {
      if (rect.right > left - 8 && rect.left < left + width + 8) blocked.push(rect);
    });
  }
  footerUx.querySelectorAll('.footer__accordion-icon, .footer__social a, .footer__payment-icons li').forEach(function(element) {
    var rect = element.getBoundingClientRect();
    if (rect.width && rect.height && rect.right > left - 8 && rect.left < left + width + 8 && (!element.closest('details:not([open])') || element.closest('summary'))) blocked.push(rect);
  });
  document.querySelectorAll('.g-recaptcha > .grecaptcha-badge').forEach(function(element) {
    var rect = element.getBoundingClientRect();
    if (rect.width && rect.height && rect.right > left - 12 && rect.left < left + width + 12) blocked.push(rect);
  });
  var top = Math.max(minimum, bottom - height);
  for (var candidate = top; candidate >= minimum; candidate -= 4) {
    if (!blocked.some(function(rect) { return candidate < rect.bottom + 12 && candidate + height > rect.top - 12; })) return candidate;
  }
  return minimum;
}

function footerUpdateWidgets() {
  footerUpdateScheduled = false;
  if (!footerUx || !footerUx.isConnected || document.hidden) return;
  if (window.innerWidth >= 800 && window.innerWidth <= 1100) {
    var contact = footerUx.querySelector('[data-type="contact"]');
    var payment = footerUx.querySelector('[data-type="payment"]');
    if (contact && payment) {
      var difference = payment.getBoundingClientRect().height - contact.getBoundingClientRect().height;
      footerSetProperty(footerUx, '--footer-legal-offset', -Math.max(0, difference) + 'px');
      footerSetProperty(footerUx, '--footer-benefits-offset', -Math.max(0, -difference) + 'px');
    }
  }
  var rect = footerUx.getBoundingClientRect();
  var inView = rect.top < window.innerHeight && rect.bottom > 0;
  document.body.classList.toggle('av-footer-in-view', inView);
  var preview = document.getElementById('PBarNextFrameWrapper');
  if (preview && footerResizeObserver) footerResizeObserver.observe(preview);
  var previewHeight = preview ? preview.getBoundingClientRect().height : 0;
  footerSetProperty(footerUx, '--footer-preview-offset', previewHeight + 'px');
  var badge = document.querySelector('[data-testid="minimized-trustbadge-floating"]');
  if (badge && badge.parentElement && !badge.parentElement.classList.contains('av-footer-trust-shell')) badge.parentElement.classList.add('av-footer-trust-shell');
  var trustRoot = badge && badge.closest('[id^="trustbadge-container-"]');
  if (trustRoot !== footerTrustRoot) {
    if (footerTrustObserver) footerTrustObserver.disconnect();
    footerTrustRoot = trustRoot;
    if (trustRoot && window.MutationObserver) {
      footerTrustObserver = new MutationObserver(footerScheduleUpdate);
      footerTrustObserver.observe(trustRoot, { subtree: true, attributes: true, childList: true, attributeFilter: ['class', 'style'] });
    }
  }
  var anchor = footerUx.querySelector('[data-footer-trust-anchor]');
  if (inView && anchor) {
    var anchorRect = anchor.getBoundingClientRect();
    footerSetProperty(document.documentElement, '--av-footer-trust-top', anchorRect.top + 'px');
    footerSetProperty(document.documentElement, '--av-footer-trust-left', anchorRect.left + 'px');
  }
  var ready = String(inView && footerWidgetVisible(badge));
  if (footerUx.dataset.trustReady !== ready) footerUx.dataset.trustReady = ready;
  var feedback = document.querySelector('[id^="hj-survey-toggle-"]');
  var feedbackRoot = feedback && feedback.parentElement;
  if (feedbackRoot !== footerFeedbackRoot) {
    if (footerFeedbackObserver) footerFeedbackObserver.disconnect();
    footerFeedbackRoot = feedbackRoot;
    if (feedbackRoot && window.MutationObserver) {
      footerFeedbackObserver = new MutationObserver(footerScheduleUpdate);
      footerFeedbackObserver.observe(feedbackRoot, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }
  var survey = feedbackRoot && feedbackRoot.querySelector('section[aria-hidden]');
  var feedbackClosed = !!survey && survey.getAttribute('aria-hidden') === 'true';
  if (feedbackRoot) feedbackRoot.classList.toggle('av-footer-feedback-closed', feedbackClosed);
  if (feedback && !feedback.title) feedback.title = feedback.getAttribute('aria-label') || '';
  var chat = document.getElementById('cx-armin-chat-widget-v2');
  if (chat !== footerChatRoot) {
    if (footerChatObserver) footerChatObserver.disconnect();
    footerChatRoot = chat;
    if (chat && window.MutationObserver) {
      footerChatObserver = new MutationObserver(footerScheduleUpdate);
      footerChatObserver.observe(chat, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class'] });
    }
  }
  var frame = chat && chat.querySelector('iframe[title="Armin CX Chat Widget"]');
  var chatButton = chat && chat.querySelector('button');
  if (chatButton && !chatButton.title) chatButton.title = chatButton.getAttribute('aria-label') || '';
  var panel = frame && frame.parentElement;
  var panelRect = panel && panel.getBoundingClientRect();
  var panelStyle = panel && window.getComputedStyle(panel);
  var chatOpen = !!(panelRect && panelRect.width > 200 && panelRect.height > 200 && panelStyle.display !== 'none' && Number(panelStyle.opacity) > 0);
  document.body.classList.toggle('av-footer-chat-open', chatOpen);
  document.querySelectorAll('.g-recaptcha > .grecaptcha-badge').forEach(function(inlineBadge) {
    var host = inlineBadge.parentElement;
    footerSetProperty(host, '--av-recaptcha-scale', String(Math.min(1, host.clientWidth / 256)));
  });
  var captcha = Array.from(document.querySelectorAll('.grecaptcha-badge:not([data-style="inline"])')).find(function(element) {
    return !element.closest('.g-recaptcha') && footerWidgetVisible(element);
  });
  if (captcha !== footerCaptcha) {
    if (footerCaptchaObserver) footerCaptchaObserver.disconnect();
    footerCaptcha = captcha;
    if (captcha && footerCaptchaObserver) footerCaptchaObserver.observe(captcha);
  }
  var chatHeight = footerWidgetVisible(chatButton) || chatOpen ? 56 : 0;
  var feedbackHeight = feedbackClosed && footerWidgetVisible(feedback) ? 44 : 0;
  var captchaHeight = captcha ? captcha.getBoundingClientRect().height : 0;
  var heights = [feedbackHeight, captchaHeight, chatHeight].filter(function(height) { return height > 0; });
  var totalHeight = heights.reduce(function(total, height) { return total + height; }, 0) + Math.max(0, heights.length - 1) * 12;
  var bottom = window.innerHeight - previewHeight - 16;
  var header = document.getElementById('SiteHeader');
  var minimum = header ? Math.max(16, Math.min(160, header.getBoundingClientRect().bottom + 12)) : 16;
  var closing = footerUx.querySelector('.footer__closing-row');
  if (inView && closing) bottom = Math.min(bottom, closing.getBoundingClientRect().top - 12);
  var inlineCaptchaInView = Array.from(document.querySelectorAll('.g-recaptcha > .grecaptcha-badge')).some(function(element) {
    var bounds = element.getBoundingClientRect();
    return bounds.bottom > 0 && bounds.top < window.innerHeight;
  });
  var top = inView || inlineCaptchaInView ? footerFloatingTop(totalHeight, captcha ? captcha.getBoundingClientRect().width : 56, bottom, minimum) : bottom - totalHeight;
  var root = document.documentElement;
  footerSetProperty(root, '--av-feedback-top', top + 'px');
  if (feedbackHeight) top += feedbackHeight + 12;
  footerSetProperty(root, '--av-captcha-top', top + 'px');
  if (captchaHeight) top += captchaHeight + 12;
  footerSetProperty(root, '--av-chat-top', top + 'px');
  if (!document.body.classList.contains('av-floating-ready')) document.body.classList.add('av-floating-ready');
}

function footerScheduleUpdate() {
  if (footerUpdateScheduled || document.hidden) return;
  footerUpdateScheduled = true;
  window.requestAnimationFrame(footerUpdateWidgets);
}

function footerInit() {
  var nextFooter = document.querySelector('footer.footer-ux');
  if (nextFooter !== footerUx) {
    footerUx = nextFooter;
    footerAccordionMode = undefined;
    if (footerResizeObserver) {
      footerResizeObserver.disconnect();
      if (footerUx) footerResizeObserver.observe(footerUx);
    }
    if (footerUx) footerUx.addEventListener('toggle', footerScheduleUpdate, true);
  }
  footerUpdateAccordions();
  footerScheduleUpdate();
}

function footerUpdateAccordions() {
  if (!footerUx || footerAccordionMode === footerMobileQuery.matches) return;
  footerAccordionMode = footerMobileQuery.matches;
  footerUx.querySelectorAll('.footer__accordion').forEach(function(previous) {
    var container = document.createElement(footerAccordionMode ? 'details' : 'div');
    container.className = previous.className;
    var previousTitle = previous.querySelector('.footer__title');
    if (previousTitle) {
      var title = document.createElement(footerAccordionMode ? 'summary' : 'h2');
      title.className = previousTitle.className;
      while (previousTitle.firstChild) title.appendChild(previousTitle.firstChild);
      previousTitle.replaceWith(title);
    }
    while (previous.firstChild) container.appendChild(previous.firstChild);
    previous.replaceWith(container);
  });
  footerScheduleUpdate();
}

footerInit();
window.addEventListener('scroll', footerScheduleUpdate, { passive: true });
window.addEventListener('resize', footerScheduleUpdate);
window.addEventListener('pageshow', footerInit);
document.addEventListener('visibilitychange', footerScheduleUpdate);
document.addEventListener('shopify:section:load', footerInit);
footerMobileQuery.addEventListener('change', footerUpdateAccordions);
if (window.MutationObserver) {
  new MutationObserver(function(records) {
    var widgetsAdded = records.some(function(record) {
      return Array.from(record.addedNodes).some(function(node) {
        return node.nodeType === 1 && (node.matches(footerWidgetSelector) || node.querySelector(footerWidgetSelector));
      });
    });
    if (widgetsAdded) footerScheduleUpdate();
  }).observe(document.body, { childList: true, subtree: true });
}

  } catch(e) { console.error(e); }
})();
})();
